import { render, staticRenderFns } from "./TeamsTable.component.vue?vue&type=template&id=1c608f95"
import script from "./TeamsTable.component.vue?vue&type=script&lang=js"
export * from "./TeamsTable.component.vue?vue&type=script&lang=js"
import style0 from "./TeamsTable.component.vue?vue&type=style&index=0&id=1c608f95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports